module.exports = __WEBPACK_EXTERNAL_createRequire(import.meta.url)("node:perf_hooks");